import { apiFetch } from '../helpers/api-fetch';
import { Representative } from '../models/representative';
import { Role } from '../helpers/role';

export class RepresentativeService {

    static readonly APIUrl = process.env.REACT_APP_API_URL as string; // API server domain

    // Get all Users
    public static async getAll() {
        const res = await apiFetch(`${RepresentativeService.APIUrl}/api/representatives`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Get User by id
    public static async getById(id: string) {
        const res = await apiFetch(`${RepresentativeService.APIUrl}/api/representatives/${id}`, {
            method: 'GET'
        });
        return Promise.resolve(res);
    }

    // Register a new User or update its data
    public static createOrUpdate(user: Representative) {
        // set username and role
        user.username = user.email;
        user.role = Role.User;
        
        return apiFetch(`${RepresentativeService.APIUrl}/api/representatives`, {
            method: 'POST',
            body: JSON.stringify(user)
        }).then(res => {
            return Promise.resolve(res);
        });
    }



}